import {Component, inject, Input} from '@angular/core';
import {Organization} from '../../../../shared/model/organization';
import {Event} from '../../../../shared/model/event';
import {GenericCardComponent} from '../../../../shared/components/generic-card/generic-card.component';
import {PermissionService} from '../../../../core/services/permission.service';
import {UserGeolocationService} from '../../../../shared/services/user-geolocation.service';
import {organizationCoordinates} from '../../../../shared/utils/map-markers';
import {distanceFromUserLabel} from '../../../../shared/utils/geo-distance';
import {TruncatePipe} from '../../../../shared/pipes/truncate.pipe';

@Component({
  selector: 'app-organization-card',
  standalone: true,
  imports: [GenericCardComponent, TruncatePipe],
  templateUrl: './organization-card.component.html',
  styleUrl: './organization-card.component.css',
})
export class OrganizationCardComponent {
  @Input({required: true}) organization!: Organization;
  @Input() events: readonly Event[] = [];
  private permissionService = inject(PermissionService);
  private userGeolocation = inject(UserGeolocationService);

  protected distanceLabel(): string {
    const coords = organizationCoordinates(this.organization.id, this.events);
    return distanceFromUserLabel(this.userGeolocation.position(), coords);
  }

  canOpenEdit(): boolean {
    return (
      this.permissionService.canEditOrg(this.organization) ||
      this.permissionService.canManageOrgMembers(this.organization)
    );
  }
}
